module.exports = __webpack_public_path__ + "static/mo38-a780755b17323d967195e23a60a8cedb.png";